import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

const CGUPage = () => {
    const lastUpdate = "03 septembre 2025";

    const sections = [
        { id: "objet", title: "1. Objet", content: "Les présentes Conditions Générales d’Utilisation (CGU) ont pour objet de définir les modalités d’accès et d’utilisation des services proposés par notre plateforme. Elles s’appliquent à tous les utilisateurs, qu’ils soient abonnés ou non." },
        { id: "acceptation", title: "2. Acceptation des CGU", content: "L’utilisation de notre service implique une acceptation sans réserve des présentes CGU. En vous inscrivant ou en accédant à nos services, vous reconnaissez avoir pris connaissance et accepté ces conditions." },
        { id: "acces", title: "3. Accès au service", content: "L’accès à notre plateforme est réservé aux utilisateurs disposant d’un compte valide. Vous êtes responsable de la confidentialité de vos identifiants et de toutes les activités effectuées sous votre compte." },
        { id: "compte", title: "4. Compte utilisateur", content: "Pour accéder à nos services, vous devez créer un compte en fournissant des informations exactes et complètes. Vous vous engagez à maintenir la confidentialité de vos informations de connexion." },
        { id: "utilisation", title: "5. Règles d’utilisation", content: "Vous vous engagez à utiliser notre service conformément à la législation en vigueur et à ne pas perturber son bon fonctionnement. Toute utilisation abusive pourra entraîner la suspension ou la résiliation de votre compte." },
        { id: "fonctionnalites", title: "6. Fonctionnalités proposées", content: "Notre plateforme offre diverses fonctionnalités, telles que la gestion de projet, la facturation, et le suivi des tâches. Les détails spécifiques de chaque fonctionnalité sont disponibles sur notre site." },
        { id: "responsabilite", title: "7. Responsabilité", content: "Nous mettons tout en œuvre pour assurer la disponibilité et la sécurité de nos services. Cependant, nous ne pouvons être tenus responsables des interruptions ou des erreurs indépendantes de notre volonté." },
        { id: "propriete", title: "8. Propriété intellectuelle", content: "Tous les contenus présents sur notre plateforme, y compris les textes, images, et logos, sont protégés par des droits de propriété intellectuelle. Toute reproduction ou utilisation non autorisée est interdite." },
        { id: "donnees", title: "9. Données personnelles", content: "Nous collectons et traitons vos données personnelles conformément à notre Politique de Confidentialité. Vous disposez de droits d’accès, de rectification et de suppression de vos données." },
        { id: "securite", title: "10. Sécurité", content: "Nous mettons en place des mesures techniques et organisationnelles pour protéger vos données. Toutefois, aucune méthode de transmission sur Internet n’est totalement sécurisée." },
        { id: "paiement", title: "11. Tarifs & paiement", content: "Nos services sont proposés selon différents plans tarifaires. Les modalités de paiement, y compris les options disponibles et les conditions de facturation, sont détaillées sur notre site." },
        { id: "resiliation", title: "12. Suspension & résiliation", content: "Vous pouvez résilier votre abonnement à tout moment selon les modalités prévues. Nous nous réservons le droit de suspendre ou de résilier votre accès en cas de non-respect des CGU." },
        { id: "modifs", title: "13. Modifications des CGU", content: "Nous nous réservons le droit de modifier les présentes CGU. Toute modification sera publiée sur notre site et prendra effet dès sa mise en ligne." },
        { id: "droit", title: "14. Droit applicable & litiges", content: "Les présentes CGU sont régies par le droit français. En cas de litige, les tribunaux compétents seront ceux du ressort de notre siège social." },
        { id: "contact", title: "15. Contact", content: "Pour toute question ou information complémentaire, vous pouvez nous contacter via notre formulaire de contact disponible sur notre site." },
    ];

    return (
        <>
            <Navbar />
            <main className="min-h-screen bg-white font-Poppins lg:pt-20 pt-10" id="cgu">
                <div className="mx-auto max-w-5xl px-4 sm:px-6 lg:px-8 py-12">
                    {/* En-tête */}
                    <header className="mb-12 text-start ">
                        <h1 className="text-3xl sm:text-4xl font-bold lg:text-5xl font-Poppins tracking-tight text-color1 mb-3">
                            Conditions générales d'utilisation

                        </h1>

                        <p className="text-sm sm:text-base text-gray-600 font-thin">
                            Version&nbsp;: {lastUpdate}
                        </p>
                    </header>

                    {/* Sommaire */}
                    <nav
                        aria-label="Sommaire"
                        className="mb-10 rounded-2xl border border-color3 p-6 shadow-sm font-Poppins"
                    >
                        <h2 className="text-lg font-semibold text-color1 mb-4">
                            Sommaire
                        </h2>
                        <ul className="grid gap-3 sm:grid-cols-2">
                            {sections.map((s) => (
                                <li key={s.id}>
                                    <a
                                        href={`#${s.id}`}
                                        className="text-sm sm:text-base text-gray-700 hover:underline"
                                    >
                                        {s.title}
                                    </a>
                                </li>
                            ))}
                        </ul>
                    </nav>

                    {/* Contenu */}
                    <div className="space-y-12">
                        {sections.map((s) => (
                            <section key={s.id} id={s.id}>
                                <h3 className="text-2xl sm:text-3xl font-bold text-color1 mb-4 text-start font-Poppins">
                                    {s.title}
                                </h3>
                                <p className="text-gray-700 text-base sm:text-lg leading-relaxed text-justify  font-Poppins ">
                                    {s.content}
                                </p>
                            </section>
                        ))}
                    </div>


                </div>
            </main>
            <Footer />
        </>
    );
}
export default CGUPage;